class animateHelper {
	constructor() {
		this.end = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
	}

	init() {
	}

	transition(target, animation, phase, endClass) {
		$(target).addClass([animation, endClass]).one(this.end, () => {
			$(target).removeClass(phase == 'in' ? animation : [animation, endClass])
		})
	}
	layers() {
		$('.nav-tabs a').click(function(e){
			var selected = $(this).html();
			$('#layersDropdownMenuButton').html(selected);
		})
	}
}

window.app.add('animate', new animateHelper());